import React from 'react';
import PropTypes from 'prop-types';

import styles from './coachInfo.scss';

const CoachInfo = ({ coach, 'data-testid': dataTestId }) => {
    return (
        <div className={styles.coachInfo} data-testid={dataTestId}>
            <div className={styles.infoRow} data-testid={dataTestId && `${dataTestId}.name-row`}>
                <span className={styles.infoLabel} data-testid={dataTestId && `${dataTestId}.name-label`}>Name</span>
                <span className={styles.infoValue} data-testid={dataTestId && `${dataTestId}.name-value`}>
                    {coach.firstName} {coach.lastName}
                </span>
            </div>
            <div className={styles.infoRow} data-testid={dataTestId && `${dataTestId}.relationship-row`}>
                <span className={styles.infoLabel} data-testid={dataTestId && `${dataTestId}.relationship-label`}>Relationship</span>
                <span className={styles.infoValue} data-testid={dataTestId && `${dataTestId}.relationship-value`}>
                    {coach.relationship}
                </span>
            </div>
            {!!coach.email && (
                <div className={styles.infoRow} data-testid={dataTestId && `${dataTestId}.email-row`}>
                    <span className={styles.infoLabel} data-testid={dataTestId && `${dataTestId}.email-label`}>Email</span>
                    <a
                        className={`${styles.infoValue} ${styles.infoLink}`}
                        href={`mailto:${coach.email}`}
                        data-testid={dataTestId && `${dataTestId}.email-link`}
                    >
                        {coach.email}
                    </a>
                </div>
            )}
            {!!coach.phone && (
                <div className={styles.infoRow} data-testid={dataTestId && `${dataTestId}.phone-row`}>
                    <span className={styles.infoLabel} data-testid={dataTestId && `${dataTestId}.phone-label`}>Phone Number</span>
                    <a
                        className={`${styles.infoValue} ${styles.infoLink}`}
                        href={`tel:${coach.phone}`}
                        data-testid={dataTestId && `${dataTestId}.phone-link`}
                    >
                        {coach.phone}
                    </a>
                </div>
            )}
        </div>
    );
};

CoachInfo.propTypes = {
    coach: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        relationship: PropTypes.string,
        email: PropTypes.string,
        phone: PropTypes.string,
    }).isRequired,
    'data-testid': PropTypes.string,
};

CoachInfo.defaultProps = {
    'data-testid': null,
};

export default CoachInfo;
